<template>
    <div class="add-single">
      <el-form ref="singleForm" :model="singleForm" :rules="rules" label-width="120px">
          <el-row >
              <el-col :lg="10" :offset="3">
                  <el-form-item label="品牌:" prop="brand_id">
                      <el-radio-group v-model="singleForm.brand_id" @change="checkinput" >
                          <el-radio :label="1">N牌</el-radio>
                          <el-radio :label="2">S牌</el-radio>
                      </el-radio-group>
                  </el-form-item>
              </el-col>
              <el-col :lg="10" >
                  <el-form-item label="系列別:" prop="class_key">
                      <el-select v-model="singleForm.class_key" placeholder="">
                          <el-option v-for="item in classList" :label="item.name" :value="item._key" :key="item._key"></el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="10" :offset="2">
                  <el-form-item label="單品編號:" prop="id">
                      <el-input v-model="singleForm.id" style="width:50%;"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :lg="10" >
                  <el-form-item label="單品名稱:" prop="name">
                      <el-input v-model="singleForm.name" style="width:50%;"></el-input>
                  </el-form-item>
              </el-col>
              
          </el-row>
          <el-row>
              <el-col :lg="10" :offset="2">
                  <el-form-item label="個人業績:" prop="personal_performance">
                            <el-select v-model="singleForm.personal_performance" >
                      <el-option v-for="item in option"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                  </el-select>
                  
                  </el-form-item>
              </el-col>
              <el-col :lg="10" >
                  <el-form-item label="係數:" prop="performance_ratio">
                      <el-input type="number" v-model.number="singleForm.performance_ratio" step="0.01" style="width:50%;"  v-if="checkNum"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
        
          <el-row>
              <el-col :lg="10" :offset="2">
                  <el-form-item label="單位:">
                    <el-input v-model="singleForm.spec" style="width:50%;"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="10" >
                 <el-form-item label="售價:" v-if="noSale">
                      <el-input type="number" v-model.number="singleForm.price" style="width:50%;" ></el-input>
                  </el-form-item>
                  
              </el-col>
          </el-row>
           <el-row>
              <el-col :lg="10" :offset="2">
              <el-form-item label="特價品:">
                      <el-checkbox v-model="singleForm.on_sale" style="width:50%" @change="checkSale" ></el-checkbox>
              </el-form-item>
              </el-col>
              <el-col :lg="10" >
                 <el-form-item label="折扣期限:" prop="startDate" v-if="isShowSale">
                      <el-date-picker v-model="date" type="daterange" range-separator="到" start-placeholde="開始日期" end-placeholde="結束日期" unlink-panels  ></el-date-picker>
                 </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="10" :offset="2">
                  <el-form-item label="身分:" v-if="isShowSale">
                      <el-tag type="info" color="#409EFF" effect="dark" >非會員</el-tag>
                      
                  </el-form-item>
              </el-col>
              <el-col :lg="10" >
                  <el-form-item label="售價:" v-if="isShowSale">
                      <el-input type="number" v-model.number="singleForm.onsalePrice" style="width:50%;" ></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="10" :offset="2">
                  <el-form-item label="身分:" v-if="isShowSale">
                      <el-tag color="#f9c6ba" effect="dark" style="color:red; border-color:red;">{{this.level1}}</el-tag>
                  </el-form-item>
              </el-col>
              <el-col :lg="10" >
                   <el-form-item label="折扣價:" v-if="isShowSale">
                      <el-input type="number" v-model.number="singleForm.memberdiscount_1" style="width:50%;"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="10" :offset="2">
                  <el-form-item label="身分:" v-if="isShowSale">
                      <el-tag color="#f9c6ba" effect="dark" style="color:#494ca2;border-color:red;">{{this.level2}}</el-tag>
                  </el-form-item>
              </el-col>
              <el-col :lg="10" >
                    <el-form-item label="折扣價:" v-if="isShowSale">
                      <el-input type="number" v-model.number="singleForm.memberdiscount_2" style="width:50%;"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
       
         
         <el-row>
             <el-col :lg="10" :offset="2">
       <el-form-item label="單品圖片:" >
      <el-upload
        ref="upload"
        action="#"
        :http-request="uploadFileMethod"
        accept="image/png,image/gif,image/jpg,image/jpeg"
        list-type="picture-card"
        :limit=limitNum
        :auto-upload="false"
        :on-exceed="handleExceed"
        :before-upload="handleBeforeUpload"
        :on-preview="handlePictureCardPreview"
        :on-success="handleSuccess"
        :on-remove="handleRemove">
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </el-form-item>
    <el-form-item>
      <el-button size="small" type="primary" @click="uploadFile">上傳</el-button>
    
    </el-form-item>
             </el-col>
             <el-col :lg="10">
             
             </el-col>
         </el-row>
         <el-row>
             <el-col :lg="10" :offset="2">
                 <el-button type="primary" @click="addProduct('singleForm')">新增</el-button>
                 <el-button type="default" @click="back">返回</el-button>
             </el-col>
             <el-col :lg="12"></el-col>
         </el-row>
         
         
          
      </el-form>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
import axios from 'axios'
    export default {
        name: 'addSingle',
        props: {
            itemType: Number
        },
        data() {
            let checkInput = (rule, value, callback) =>{
                if(!value){
                    return new Error('請填入係數')
                }else {
                    if(this.singleForm.personal_performance == 1){
                        if(value < 1){
                             callback(new Error('不能小於1'))
                        }else if(value > 10){
                             callback(new Error('不能大於10'))
                        }
                    }else if(this.singleForm.personal_performance == 2){
                        if(value < 0.1){
                             callback(new Error('不能小於0.1'))
                        }else if(value > 0.9){
                             callback(new Error('不能大於0.9'))
                        }else {
                            callback()
                        }
                    }
                }
            }
            return {
                   singleForm:{
                on_sale: false,
                on_sale_start: '',
                on_sale_end: '',
                brand_id: 1,
                class_key: '',
                id: '',
                name: '',
                price: 0,
                onsalePrice: 0,
                memberdiscount_1: 0,
                memberdiscount_2: 0,
                personal_performance: null,
                performance_ratio: '',
                spec: '',
                images:[],
                   },
                   level1: '',
                   level2: '',
                   pr: '',
                cleanForm: {
                          on_sale: true,
                on_sale_start: '',
                on_sale_end: '',
                brand_id: 1,
                class_key: '',
                id: '',
                name: '',
                price: 0,
                 memberdiscount_1: 0,
                memberdiscount_2: 0,
                personal_performance: null,
                performance_ratio: '',
                spec: '',
                images:[],
                },   
            imageUrl: [],
            key: '',
            pic: '',
            bid: {},
             dialogImageUrl: '',
             date: [],
             noSale: true,
        dialogVisible: false,
        disabled: false,
        formLabelWidth: '80px',
      limitNum: 3,
      checkNum: true,
      checkDub: false,
      isShowSale: false,
      strStartDate: '',
            strEndDate: '',
            classList: [],
            Price: 0,
            option: [{
                label: '加成',
                value: 1
            }, {
                label: '折扣',
                value: 2
            }
            ],
            startDate: [],
            rules: {
                name: [
                    {required: true, message: '請輸入名稱'}
                ],
                id:[
                    {required: true, message: '請輸入編號'}
                ],
                class_key: [
                    {required: true, message: '請輸入系列別'}
                ],
                personal_performance: [
                    {required: true, message: '請輸入個人業績'}
                ],
                performance_ratio: [
                    {required: true, message: '請輸入係數'},
                    {validator: checkInput, trigger: 'blur'}
                ]
             

            }
            
              
            }
        },
        computed: mapGetters(["getClassList", "getProductError", "getProductMsg", "getFileKey", "getImageFile", "getImages"]),
        methods: {
            ...mapActions(["fetchClassList", "addProduct", "addProductFile", "LoadFile"]),
            async fetchClassList(){

               if(this.singleForm.brand_id != null){
                   this.bid = {
                       brand_id: this.singleForm.brand_id,
                       is_create: "創造"
                       }
               }else {
                   this.bid = {is_create: "創造"}
               }
                await this.$store.dispatch('fetchClassList', this.bid)
             
                this.classList =  await this.getClassList
            },
            checkinput(){
                this.fetchClassList()
                     if(this.singleForm.brand_id == 1){
                    this.level1 = '白金'
                    this.level2 = '尊爵'
                }else if (this.singleForm.brand_id == 2){
                    this.level1 = '芙蓉'
                    this.level2 = '金鑽'
                }
              },
           
           async  uploadFileMethod(param) {
            
            let fileObject = param.file;
            let formData = new FormData();
            formData.append("file", fileObject);

            await this.$store.dispatch("addProductFile",  formData)
            this.imageKey = await this.getFileKey
            this.imageUrl = await this.getImageFile
            await this.singleForm.images.push(
                this.imageKey
            )
          },
          async addProduct(formName){
               if(this.date != null){
                    if (typeof(this.date[0]) != String) {
              
                        this.strStartDate = moment(this.date[0]).format("YYYY-MM-DD")
              this.strEndDate = moment(this.date[1]).format("YYYY-MM-DD")
                
              }else {
                  this.strStartDate = this.date[0]
                  this.strEndDate = this.date[1]
              }
              }else {
                  this.strStartDate = ''
                  this.strEndDate = ''
              }
              this.pr = String(this.singleForm.performance_ratio);
              
              if (this.singleForm.price != 0) {
                  this.Price = this.singleForm.price
              }else if(this.singleForm.onsalePrice != 0)  {
                   this.Price = this.singleForm.onsalePrice
              }
              const data = {
                  on_sale: this.singleForm.on_sale,
                  on_sale_start:  this.strStartDate,
                  on_sale_end: this.strEndDate,
                  brand_id: this.singleForm.brand_id,
                  name: this.singleForm.name,
                  id: this.singleForm.id,
                  class_key: this.singleForm.class_key,
                    price: this.Price,
                   personal_performance: this.singleForm.personal_performance,
                  performance_ratio: this.pr,
                  memberdiscount_1: this.singleForm.memberdiscount_1,
                  memberdiscount_2: this.singleForm.memberdiscount_2,
                  images: this.singleForm.images,
                  spec: this.singleForm.spec,
                  type: this.itemType
              }
              await this.$store.dispatch('addProduct', data)
                  if (this.getProductError == true) {
                       this.$notify({
                          title: '失敗',
                          message: this.getProductMsg,
                          type: 'error',
                          duration: '4500',
                          position: 'top-right'
                      });
                      
                  }else {
                        this.$emit('back')
                               this.$notify({
                          title: '成功',
                          message: '新增單品產品成功',
                          type: 'success',
                          duration: '4500',
                          position: 'top-right'
                      });
                      this.$refs[formName].resetFields()
                      this.singleForm = this.cleanForm
                    

                     
                  }

          },
        async loadProductImage(key){
         await this.$store.dispatch('LoadFile', key)
         this.images.forEach(image => {
             this.imageUrl.push({
              imageUrl:   window.URL.createObjectURL(image)
             })
         });
        
         
        },
        checkSale(){
            this.noSale = !this.noSale
            this.isShowSale = !this.isShowSale
                     if(this.singleForm.brand_id == 1){
                    this.level1 = '白金'
                    this.level2 = '尊爵'
                }else if (this.singleForm.brand_id == 2){
                    this.level1 = '芙蓉'
                    this.level2 = '金鑽'
                }
        },
          
            back(){
                this.$emit('back')
              
                      this.singleForm = this.cleanForm
            },
       handleBeforeUpload(file){
      console.log('before')
      if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        this.$notify.warning({
          title: '警告',
          message: '請上傳格式為 image/png, image/gif, image/jpg, image/jpeg的圖片'
        })
      }
      let size = file.size / 1024 / 1024 / 2
      if(size > 2) {
        this.$notify.warning({
          title: '警告',
          message: '圖片大小必須小於2M'
        })
      }
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {

    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      console.log(file);
    },
    handleSuccess(response, file, fileList){
        console.log(response)
        this.$notify({
            title: '成功',
            message: '上傳圖片成功',
            type: 'success',
            duration: '4500',
            position: 'top-right'
        });
        
    },
    uploadFile() {
      this.$refs.upload.submit()
    },
    test(){
        console.log(this.singleForm.personal_performance);
    },
    
   
       
        },
        created() {
            this.fetchClassList()
        }
    }
</script>

<style lang="scss"  >
    
    .el-form-item {
        label {
            font-size: 18px;
             font-weight: bold;
         font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        }
    }
</style>